import { useContext, useMemo } from "react";
import type { Language } from "./language.ts";
import type { TextKey } from "./en.ts";
import { LanguageContext } from "./languageContext.ts";
import { translate } from "./translate.ts";

export { translate, pluralText } from "./translate.ts";
export type { Translate } from "./translate.ts";

/** For language-sensitive formatting (dates, numbers) that useT() doesn't cover, e.g. `toLocaleString` via `localeFor()` in model/language.ts. */
export function useLanguage(): Language {
  return useContext(LanguageContext);
}

/** Falls back to English without a `LanguageProvider` above (LanguageContext's own default). */
export function useT() {
  const language = useContext(LanguageContext);
  return useMemo(
    () =>
      function t(key: TextKey, params?: Record<string, string | number>): string {
        return translate(language, key, params);
      },
    [language]
  );
}
